export default () => `
<section id="banner" class="bounce-in-down flex flex--column align-items-center">
  <a href="https://www.stltoday.com/brandavestudios/restaurants-people-and-more-meet-the-very-best-of-southwest-illinois/article_fcebabd5-b15f-5980-86bc-77d49a8858d4.html" target="_blank"><h2>Best Mexican Restaurant of Southwest Illinois - 2019! 🎊</h2></a>
  <ul><li>T - F 11A - 9P</li><li>Sat. Noon - 9P</li><li>Sun. 11A - 9P</li></ul>
</section>
`;
